import classNames from 'classnames';
import { Button, FlexContainer, Txt } from 'components';
import { observer } from 'mobx-react-lite';
import { leaveAReviewUrl } from 'config';
import { useTenancy } from 'state';
import styles from './TodoItemPropertyOccupied.module.scss';

/**
 * TodoItemPropertyOccupied
 *
 * @return {JSX.Element}
 */
const TodoItemPropertyOccupied = ({ className }) => {
  const tenancyDoc = useTenancy();
  const isDone = tenancyDoc.propertyIsOccupied;

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemPropertyOccupied,
        className,
        TodoItemPropertyOccupied.displayName
      )}
      column
      gap
    >
      {isDone ? (
        <>
          <Txt bold>You've moved in 🏡 🎉</Txt>
          <Txt regular>Congratulations and welcome to your property!</Txt>
          <Txt regular>
            If you've enjoyed using Propa please take a minute to leave a review
            on TrustPilot using the button below.
          </Txt>
          <a
            href={leaveAReviewUrl}
            target="_blank"
            className={styles.ButtonLink}
            rel="noreferrer"
          >
            <Button success flex>
              Leave a Review
            </Button>
          </a>
        </>
      ) : (
        <>
          <Txt bold>🏡❓ Not moved in yet</Txt>
          <Txt regular>
            When the tenancy has started and the property is occupied your
            landlord will update its status.
          </Txt>
          <Txt regular>
            Until then please make sure your tenancy agreement is signed, you've
            paid your deposit and setup your standing order for paying your
            rent.
          </Txt>
        </>
      )}
    </FlexContainer>
  );
};

TodoItemPropertyOccupied.displayName = 'TodoItemPropertyOccupied';

export default observer(TodoItemPropertyOccupied);
